import type { UseFormReturn } from 'react-hook-form';
import { useWatch } from 'react-hook-form';
import type { UiValues } from './_shared';

/**
 * Optional job / customer name shown at the top of the calculator.
 * Pure UI metadata — never sent to the engine. Threads into pinned
 * scenarios + recent calc labels so the owner can identify whose quote a
 * snapshot belonged to without having to remember by qty + style.
 *
 * Borderless on purpose: it reads as a document title, not a form
 * field, so the form below stays the visual primary.
 */
export function JobNameInput({ form }: { form: UseFormReturn<UiValues> }) {
  const value = useWatch({ control: form.control, name: 'jobName' }) ?? '';
  return (
    <div>
      <label htmlFor="sp-job-name" className="sr-only">
        Job or customer name
      </label>
      <input
        id="sp-job-name"
        type="text"
        value={value}
        maxLength={80}
        placeholder="Untitled quote — add a job or customer name"
        onChange={(e) =>
          form.setValue('jobName', e.target.value, { shouldDirty: true, shouldValidate: false })
        }
        className="w-full bg-transparent text-lg font-semibold text-foreground placeholder:font-normal placeholder:text-muted-foreground/60 focus:outline-none"
      />
    </div>
  );
}
